import { CYAN, type PaletteEstesa } from '@/lib/appearance';

/**
 * LA PALETTE DELLA V3 — il preset «v3» di `lib/appearance.ts`, che non compare nell'elenco dei temi.
 *
 * Reference: `services/qlash-telegram-app/ui/2026-10-20-v3-fase-1-fondamenta.md` §1 (KB 0864ba03), valori
 * letti dal pacchetto `2026-10-20-qlash-v3/` di CriGio (`01-design-system.md` + `html/*.html`).
 *
 * ⛔ NON e' in `PRESETS` e NON passa da `resolvePalette`. Con `useV3()` acceso vale al posto di qualunque tema; si
 * risolve al momento di applicare (`hooks/useAppearance.ts`), e il `presetId` salvato dall'utente non si tocca:
 * spenta la v3 torna il tema di prima.
 *
 * ⛔ Questo modulo entra nel bundle SOLO attraverso `lib/v3.ts`, dentro il confronto letterale sul flag: in
 * produzione il bundler lo piega e questi valori non compaiono in `dist/` (`tools/verify-v3.ts`).
 *
 * I valori marcati «⚠️ CriGio conferma» sono quelli che la reference lascia aperti: si usano come indicati.
 */
export const PALETTE_V3: PaletteEstesa = {
  // ⚠️ CriGio conferma: il design system nomina anche `bg` #071C1B, «sfondo generico», che negli HTML compare 4
  // volte contro 175 di #050F0F.
  '--color-bg': '#050f0f',
  '--color-section': '#050f0f',
  '--color-bg-secondary': '#0d2826', // surface
  '--color-bg-tertiary': '#153734', // surface-2
  '--color-border': '#1d423e', // line
  '--color-fg': '#eef6f5', // text
  // ⚠️ CriGio conferma: oggi `fg-muted` fa anche da terzo livello; il v3 ha `text-3` (v. `v3.css`).
  '--color-fg-muted': '#a9c2bf', // text-2
  '--color-brand': CYAN, // accent, invariato (il valore e' uno solo: `appearance.ts`)
  '--color-brand-fg': '#032b29', // on-accent
  // ⚠️ CriGio conferma: il v3 non ha un rosso «pericolo» distinto dal «live».
  '--color-danger': '#ff4d67', // live
  '--color-success': '#3dd68c',
  '--color-warning': '#f5b53d', // warn
};
